import LIT_ACTION_CIDS from '../lit-actions-cids.json'

/**
 * IPFS hashes for the runner secret scoped lit actions.
 * IMPORTANT: This array must match ui/packages/core/src/mpc/constants.ts RUNNER_SECRET_IPFS_HASHES
 * The order and contents affect access control conditions for runner secret decryption
 */
export const RUNNER_SECRET_IPFS_HASHES: string[] = [
    LIT_ACTION_CIDS.deriveWrappedKeyAndSignCosmosTransactionScoped,
    LIT_ACTION_CIDS.deriveWrappedKeyAndSignEvmTransactionScoped,
    LIT_ACTION_CIDS.deriveWrappedKeyAndSignSolanaTransactionScoped,
    LIT_ACTION_CIDS.deriveWrappedKeyAndSignHyperCoreTransactionScoped,
    LIT_ACTION_CIDS.deriveAndGetPubKeyK256Scoped,
    LIT_ACTION_CIDS.deriveAndGetPubKeyEd25519Scoped,
    LIT_ACTION_CIDS.exportPrivateKey,
    LIT_ACTION_CIDS.encryptPrivateKey,
]

/**
 * IPFS hashes for the vault secret scoped lit actions.
 * IMPORTANT: This array must match ui/packages/core/src/mpc/constants.ts VAULT_SECRET_IPFS_HASHES
 * The order and contents affect access control conditions for root key decryption
 */
export const VAULT_SECRET_IPFS_HASHES: string[] = [
    LIT_ACTION_CIDS.generateNamadaKeySeedFromRoot,
    LIT_ACTION_CIDS.deriveNamadaKeys,
    LIT_ACTION_CIDS.signTransactionWithEncryptedNamadaKey,
    LIT_ACTION_CIDS.deriveKeyFromRoot,
    LIT_ACTION_CIDS.exportPrivateKey,
    LIT_ACTION_CIDS.encryptPrivateKey,
]

export { LIT_ACTION_CIDS }